var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row WPLayout",class:{'noColumnPadding': !_vm.layoutData.column_padding, 'noPad': _vm.layoutData.acf_fc_layout == 'full_page_width'},style:(_vm.styles)},[_c(_vm.layoutData.acf_fc_layout,_vm._b({tag:"component"},'component',_vm.layoutData,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }